/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './CrmPipelineBoardConfigurationService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService#getDefaultBoardCardConfig
 */
export const GET_DEFAULT_BOARD_CARD_CONFIG_QUERY_FIELD_NAME = 'com_hubspot_crm_pipeline_board_configuration_rpc_CrmPipelineBoardConfigurationService_getDefaultBoardCardConfig';
export const GET_DEFAULT_BOARD_CARD_CONFIG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DEFAULT_BOARD_CARD_CONFIG_QUERY_FIELD_NAME,
  args: ['objectTypeId', 'pipelineId', 'appId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getDefaultBoardCardConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService#getDefaultSectionConfigs
 */
export const GET_DEFAULT_SECTION_CONFIGS_QUERY_FIELD_NAME = 'com_hubspot_crm_pipeline_board_configuration_rpc_CrmPipelineBoardConfigurationService_getDefaultSectionConfigs';
export const GET_DEFAULT_SECTION_CONFIGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DEFAULT_SECTION_CONFIGS_QUERY_FIELD_NAME,
  args: ['sectionTypes', 'objectTypeId', 'pipelineId', 'appId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getDefaultSectionConfigsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService#getAdminBoardCardConfig
 */
export const GET_ADMIN_BOARD_CARD_CONFIG_QUERY_FIELD_NAME = 'com_hubspot_crm_pipeline_board_configuration_rpc_CrmPipelineBoardConfigurationService_getAdminBoardCardConfig';
export const GET_ADMIN_BOARD_CARD_CONFIG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ADMIN_BOARD_CARD_CONFIG_QUERY_FIELD_NAME,
  args: ['objectTypeId', 'pipelineId', 'appId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getAdminBoardCardConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService#getUserBoardCardConfig
 */
export const GET_USER_BOARD_CARD_CONFIG_QUERY_FIELD_NAME = 'com_hubspot_crm_pipeline_board_configuration_rpc_CrmPipelineBoardConfigurationService_getUserBoardCardConfig';
export const GET_USER_BOARD_CARD_CONFIG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_BOARD_CARD_CONFIG_QUERY_FIELD_NAME,
  args: ['objectTypeId', 'pipelineId', 'appId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getUserBoardCardConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService#createUserBoardCardConfig
 */
export const CREATE_USER_BOARD_CARD_CONFIG_MUTATION_FIELD_NAME = 'com_hubspot_crm_pipeline_board_configuration_rpc_CrmPipelineBoardConfigurationService_createUserBoardCardConfig';
export const CREATE_USER_BOARD_CARD_CONFIG_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_USER_BOARD_CARD_CONFIG_MUTATION_FIELD_NAME,
  args: ['boardCardSectionConfigurations', 'objectTypeId', 'pipelineId', 'appId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.createUserBoardCardConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService#createAdminBoardCardConfig
 */
export const CREATE_ADMIN_BOARD_CARD_CONFIG_MUTATION_FIELD_NAME = 'com_hubspot_crm_pipeline_board_configuration_rpc_CrmPipelineBoardConfigurationService_createAdminBoardCardConfig';
export const CREATE_ADMIN_BOARD_CARD_CONFIG_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_ADMIN_BOARD_CARD_CONFIG_MUTATION_FIELD_NAME,
  args: ['boardCardSectionConfigurations', 'objectTypeId', 'pipelineId', 'appId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.createAdminBoardCardConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService#deleteUserBoardCardConfigsForUser
 */
export const DELETE_USER_BOARD_CARD_CONFIGS_FOR_USER_MUTATION_FIELD_NAME = 'com_hubspot_crm_pipeline_board_configuration_rpc_CrmPipelineBoardConfigurationService_deleteUserBoardCardConfigsForUser';
export const DELETE_USER_BOARD_CARD_CONFIGS_FOR_USER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_USER_BOARD_CARD_CONFIGS_FOR_USER_MUTATION_FIELD_NAME,
  args: ['objectTypeId', 'pipelineId', 'appId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.deleteUserBoardCardConfigsForUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});